import { useSceneEntities } from "@/stores/SceneEntities";
import { useAssetDoorsGlassValidate } from "@/scripts/rooms/actions/general/AssetDoorsGlassValidate";
import { useAlcoveValidate1 } from "@/scripts/rooms/actions/alcove/AlcoveValidate1";
import { useAssetDoorsInvert } from "@/scripts/rooms/actions/alcove/AssetDoorsInvert";
export function useAssetDoorsInfinityHinge(payload, viewport) {
  const sceneEntities = useSceneEntities();

  let x36 = sceneEntities.getUIData("x36");

  let shower_threshold = sceneEntities.getUIData("shower_threshold");

  // let doors_x60_rotolo_barn_shower = sceneEntities.configuratorView.viewportComponent.getViewportAsset("doors_x60_rotolo_barn_shower");

  let doors_x36_infinity_hinge =
    sceneEntities.configuratorView.viewportComponent.getViewportAsset("doors_x36_infinity_hinge");

  //just disable all at first
  doors_x36_infinity_hinge.enabled = false;
  viewport.setEnabled(doors_x36_infinity_hinge);

  //since this can be used from direct ui selections of the bi pass original ui
  //or or for validation from other selections like showers or tubs , payload could be null
  // so retrieve the payload manually..

  let uiItem = sceneEntities.getUIData("infinity_hinge");
  if (x36.enabled  && !shower_threshold.enabled) {
    uiItem.disabled = false;
  } else {
    uiItem.disabled = true;
  }

  // new logic if disabled then set enabled to false
  if (uiItem.enabled && uiItem.disabled) {
    uiItem.enabled = false;
  }

  if (uiItem.enabled && !uiItem.disabled) {
    doors_x36_infinity_hinge.enabled = true;
    viewport.setEnabled(doors_x36_infinity_hinge);
  }

  useAssetDoorsGlassValidate(null, viewport); 
  useAssetDoorsInvert(null, viewport);
  useAlcoveValidate1(null, viewport);
}
